module.exports = __webpack_public_path__ + "img/ru.ef405b11.svg";